import './index.scss';
import classnames from 'classnames';
import React, { useCallback, useState } from 'react';
const Tab = ({ children }) => {
    return React.createElement(React.Fragment, null, children);
};
const Tabs = (props) => {
    const { children, defaultTab, onTabChange } = props;
    const [selectedTab, setSelectedTab] = useState(defaultTab !== null && defaultTab !== void 0 ? defaultTab : 0);
    const TabTitle = ({ title, setSelectedTab, index, selectedTab, className, }) => {
        const onClick = useCallback(() => {
            if (onTabChange) {
                onTabChange(index);
            }
            setSelectedTab(index);
        }, [setSelectedTab, index]);
        const tabItemClass = classnames('tab-list-item', { 'tab-item-active': selectedTab === index });
        if (!title && !className)
            return React.createElement(React.Fragment, null);
        return (React.createElement("li", { onClick: onClick, className: tabItemClass, key: index },
            className &&
                React.createElement("span", { className: 'tab-icon' },
                    React.createElement("i", { className: className })),
            React.createElement("span", null, title)));
    };
    const filteredChildren = children.filter(c => c);
    return (React.createElement("div", { className: 'tabs-container' },
        React.createElement("ul", { className: 'tab-list' }, filteredChildren.map((item, index) => (React.createElement(TabTitle, { key: index, title: item.props.title, index: index, setSelectedTab: setSelectedTab, selectedTab: selectedTab, className: item.props.icon })))),
        React.createElement("div", { className: "tab-content" }, filteredChildren[selectedTab])));
};
export { Tabs, Tab };
